
export const types = {
  LOAD_REQUEST: 'SingleKeyNarrative/LOAD_REQUEST',
  LOAD_COMPLETED: 'SingleKeyNarrative/LOAD_COMPLETED',
  LOAD_FAILED: 'SingleKeyNarrative/LOAD_FAILED',
}

const initialState = {
    key_narrative: [],
    is_loading: true,
    error: null,
}

export default function reducer(state = initialState, action = {}) {
  switch (action.type) {
      case types.LOAD_REQUEST:
        return { ...state, key_narrative: [], error: null, is_loading:true };
      case types.LOAD_COMPLETED:
        return { ...state, key_narrative: action.data, error: null, is_loading:false };
      case types.LOAD_FAILED:
        return { ...state, error: action.error, is_loading:false };
      default:
        return state;
    }
}

export const actions = {
  loadSingleKeyNarrativeRequest: stock_code => {
    return { type: types.LOAD_REQUEST, stock_code: stock_code };
  },
  loadSingleKeyNarrativeCompleted: data => {
    return { type: types.LOAD_COMPLETED, data: data };
  },
  loadSingleKeyNarrativeFailed: error => {
    return { type: types.LOAD_FAILED, error: error };
  }
}
